import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import NavBar from "@/components/NavBar.vue";
import { onMounted, onUnmounted } from 'vue'
import Lenis from '@studio-freight/lenis'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

let lenis: Lenis;

onMounted(() => {
  lenis = new Lenis({
    duration: 0.5,
    easing: (t: number) => t * (2 - t),
  })

  const raf = (time: number) => {
    lenis?.raf(time)
    requestAnimationFrame(raf)
  }

  requestAnimationFrame(raf)
})

onUnmounted(() => {
  lenis?.destroy()
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NavBar),
    _createVNode(_component_router_view)
  ], 64))
}
}

})